import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setShowValueFormatErrorsReducer = (state: EditorState, { payload: show }: PayloadAction<boolean>) => {
  state.showValueFormatErrors = show;
};

export default setShowValueFormatErrorsReducer;
